<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入盲盒名称"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handleAdd"
            >添加盲盒</el-button
          >

          <el-popover
            placement="bottom"
            title="显示筛选"
            trigger="click"
            width="220"
          >
            <el-checkbox-group v-model="checkedColumns">
              <el-checkbox
                v-for="item in columnOptions"
                :key="item.prop"
                :label="item.prop"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
            <div style="text-align: right; margin-top: 8px">
              <el-button size="mini" @click="handleCheckAll">全选</el-button>
              <el-button size="mini" @click="handleClearAll">清空</el-button>
            </div>
            <el-button slot="reference" icon="el-icon-s-tools" type="info"
              >列筛选</el-button
            >
          </el-popover>
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column
            label="ID"
            prop="id"
            width="80"
            align="center"
            v-if="checkedColumns.includes('id')"
          />
          <el-table-column
            label="盲盒名称"
            prop="name"
            min-width="180"
            v-if="checkedColumns.includes('name')"
          />
          <el-table-column
            label="盲盒图片"
            width="120"
            align="center"
            v-if="checkedColumns.includes('image')"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.image"
                style="width: 60px; height: 60px; object-fit: cover"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="价格"
            prop="price"
            width="100"
            align="center"
            v-if="checkedColumns.includes('price')"
          />
          <el-table-column
            label="排序"
            prop="sort"
            width="80"
            align="center"
            v-if="checkedColumns.includes('sort')"
          />
          <el-table-column
            label="销量"
            prop="sales"
            width="100"
            align="center"
            v-if="checkedColumns.includes('sales')"
          />
          <el-table-column
            label="收入"
            prop="income"
            width="100"
            align="center"
            v-if="checkedColumns.includes('income')"
          />
          <el-table-column
            label="支出"
            prop="pay"
            width="100"
            align="center"
            v-if="checkedColumns.includes('pay')"
          />
          <!-- 利润列 -->
          <el-table-column
            label="利润"
            width="120"
            align="center"
            v-if="checkedColumns.includes('profit')"
          >
            <template slot-scope="scope">
              <span v-if="Number(scope.row.income) === 0">--</span>
              <span
                v-else
                :style="{
                  color:
                    scope.row.income - scope.row.pay >= 0
                      ? '#00c48c'
                      : '#f56c6c',
                }"
              >
                {{
                  (
                    ((scope.row.income - scope.row.pay) / scope.row.income) *
                    100
                  ).toFixed(2)
                }}%
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            width="180"
            align="center"
            v-if="checkedColumns.includes('status')"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatusChange(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="created_at"
            width="180"
            v-if="checkedColumns.includes('created_at')"
          />
          <el-table-column
            label="更新时间"
            prop="updated_at"
            width="180"
            v-if="checkedColumns.includes('updated_at')"
          />
          <el-table-column
            label="操作"
            width="280"
            align="center"
            fixed="right"
            v-if="checkedColumns.includes('action')"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handleEdit(scope.row.id)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-box"
                @click.stop="openPrizeDialog(scope.row)"
                >赏品</el-button
              >
              <el-button
    type="text"
    icon="el-icon-document"
    @click.stop="openDrawRecordDialog(scope.row)"
    >抽奖记录</el-button
  >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- ==============================================
             PC 独立弹窗：添加/编辑盲盒
        ============================================== -->
        <el-dialog
          :title="dialogType == 'add' ? '添加盲盒' : '编辑盲盒'"
          :visible.sync="dialogVisible"
          width="700px"
          @close="resetForm"
          append-to-body
        >
          <el-form
            :model="form"
            :rules="addRules"
            ref="formRef"
            label-width="120px"
          >
            <el-form-item label="盲盒名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入盲盒名称"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="盲盒图片" prop="image">
              <div style="display: flex; align-items: center; gap: 12px">
                <el-button
                  type="primary"
                  icon="el-icon-picture"
                  @click="pcOpenImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="form.image"
                  style="
                    border: 1px solid #eee;
                    padding: 4px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="form.image"
                    style="
                      width: 52px;
                      height: 52px;
                      object-fit: cover;
                      display: block;
                    "
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="form.price"
                placeholder="请输入价格"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="form.sort"
                placeholder="请输入排序值"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="门票ID" prop="goods_id">
              <el-input
                v-model="form.goods_id"
                placeholder="请输入门票ID"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="预估价格" prop="loss_price">
              <el-input
                v-model="form.loss_price"
                placeholder="请输入预估价格"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="等级概率" prop="wish_probability">
              <el-table
                :data="probList"
                border
                size="mini"
                style="width: 400px"
              >
                <el-table-column
                  label="等级ID"
                  prop="level_id"
                  width="80"
                  align="center"
                />
                <el-table-column
                  label="等级名称"
                  prop="level_name"
                  min-width="100"
                />

                <el-table-column label="概率(%)">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.probability"
                      type="number"
                      size="mini"
                      style="width: 100px"
                      @change="handleProbChange"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- ==============================================
             PC 独立弹窗：图片选择
        ============================================== -->
        <el-dialog
          title="选择图片"
          :visible.sync="pcImageDialogVisible"
          width="850px"
          append-to-body
        >
          <div
            v-loading="pcImageLoading"
            element-loading-text="图片加载中..."
            style="padding: 10px"
          >
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-select
                v-model.number="pcImageSearch.type"
                placeholder="图片类型"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="pcGetImageList"
                >筛选</el-button
              >
              <el-button icon="el-icon-refresh" @click="pcResetImageSearch"
                >重置</el-button
              >
            </div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                max-height: 420px;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in pcImageList"
                :key="img.id"
                @click="pcSelectImage(img)"
                style="
                  cursor: pointer;
                  padding: 4px;
                  border-radius: 6px;
                  text-align: center;
                "
                :style="{
                  border:
                    pcSelectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    pcSelectedImageUrl == img.url ? '#f0f7ff' : '#fff',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
              </div>
            </div>
            <el-pagination
              @size-change="pcHandleImageSizeChange"
              @current-change="pcHandleImageCurrentChange"
              :current-page="pcImageSearch.page"
              :page-size="pcImageSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pcImageTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>
          <div slot="footer">
            <el-button @click="pcImageDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcConfirmSelectImage"
              >确认选择</el-button
            >
          </div>
        </el-dialog>

        <!-- ==============================================
             PC 独立弹窗：详情
        ============================================== -->
        <el-dialog
          :title="detailRow ? detailRow.name + ' 详情' : '盲盒详情'"
          :visible.sync="detailDialogVisible"
          width="800px"
          append-to-body
        >
          <div v-loading="detailLoading" style="padding: 10px 0">
            <div v-if="detailRow">
              <div
                style="display: flex; align-items: center; margin-bottom: 20px"
              >
                <img
                  :src="detailRow.image"
                  style="width: 100px; height: 100px; object-fit: cover"
                />
                <div style="margin-left: 15px">
                  <h2 style="margin: 0">{{ detailRow.name }}</h2>
                  <p style="margin: 5px 0; color: #666">
                    ID：{{ detailRow.id }}
                  </p>
                </div>
              </div>
              <el-descriptions :column="2" border size="small">
                <el-descriptions-item label="盲盒名称">{{
                  detailRow.name
                }}</el-descriptions-item>
                <el-descriptions-item label="价格">{{
                  detailRow.price
                }}</el-descriptions-item>
                <el-descriptions-item label="排序">{{
                  detailRow.sort
                }}</el-descriptions-item>
                <el-descriptions-item label="销量">{{
                  detailRow.sales
                }}</el-descriptions-item>
                <el-descriptions-item label="收入">{{
                  detailRow.income
                }}</el-descriptions-item>
                <el-descriptions-item label="支出">{{
                  detailRow.pay
                }}</el-descriptions-item>
                <el-descriptions-item label="利润">
                  <span v-if="Number(detailRow.income) === 0">--</span>
                  <span
                    v-else
                    :style="{
                      color:
                        detailRow.income - detailRow.pay >= 0
                          ? '#00C48C'
                          : '#F56C6C',
                    }"
                  >
                    {{
                      (
                        ((detailRow.income - detailRow.pay) /
                          detailRow.income) *
                        100
                      ).toFixed(2)
                    }}%
                  </span>
                </el-descriptions-item>
                <el-descriptions-item label="状态">
                  <span
                    :style="{
                      color: detailRow.status == 1 ? '#00C48C' : '#F56C6C',
                    }"
                  >
                    {{ detailRow.status == 1 ? "上架" : "下架" }}
                  </span>
                </el-descriptions-item>
                <el-descriptions-item label="创建时间">{{
                  detailRow.created_at
                }}</el-descriptions-item>
              </el-descriptions>
              <div style="margin-top: 20px" v-if="detailProbList.length">
                <p style="font-weight: bold; margin-bottom: 8px">等级概率</p>
                <el-table
                  :data="detailProbList"
                  border
                  size="mini"
                  style="width: 100%"
                >
                  <el-table-column
                    label="ID"
                    prop="level_id"
                    width="100"
                    align="center"
                  />
                  <el-table-column
                    label="等级名称"
                    prop="level_name"
                    min-width="120"
                  />
                  <el-table-column label="概率(%)" align="center">
                    <template slot-scope="scope">
                      {{ parseFloat(scope.row.probability).toFixed(2) }}%
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="margin-top: 20px; color: #999" v-else>
                暂无等级概率配置
              </div>
            </div>
          </div>
          <div slot="footer">
            <el-button @click="detailDialogVisible = false">关闭</el-button>
          </div>
        </el-dialog>
<!-- ====================== 盲盒抽奖记录弹窗 ====================== -->
<el-dialog
  title="盲盒抽奖记录"
  :visible.sync="drawRecordDialogVisible"
  width="1300px"
  top="5vh"
  append-to-body
>
  <div v-loading="drawRecordLoading">
    <!-- 搜索栏 -->
    <!-- <div style="display: flex; gap: 10px; align-items: center; margin-bottom: 15px; flex-wrap: wrap">
      <el-input
        v-model="drawRecordSearch.nickname"
        placeholder="用户昵称"
        clearable
        style="width: 200px"
      ></el-input>
      <el-select
        v-model.number="drawRecordSearch.level_id"
        placeholder="奖品等级"
        clearable
        style="width: 160px"
      >
        <el-option
          v-for="lv in drawRecordLevelList"
          :key="lv.level_id"
          :label="lv.name"
          :value="lv.level_id"
        />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="getDrawRecordList">搜索</el-button>
      <el-button icon="el-icon-refresh" @click="resetDrawRecordSearch">重置</el-button>
    </div> -->

    <el-table
      :data="drawRecordList"
      border
      stripe
      size="small"
      style="width: 100%"
    >
      <el-table-column label="记录ID" prop="id" width="90" align="center" />
      <el-table-column label="用户信息" width="220">
        <template slot-scope="scope">
          <div style="display: flex; align-items: center; gap: 8px">
            <img
              :src="scope.row.avatar"
              style="width: 36px; height: 36px; border-radius: 50%; object-fit: cover"
            />
            <div>
              <div>{{ scope.row.nickname }}</div>
              <div style="font-size: 12px; color: #999">UID:{{ scope.row.user_id }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="盲盒" width="200">
        <template slot-scope="scope">
          <div style="display: flex; align-items: center; gap: 6px">
            <img :src="scope.row.box_image" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px" />
            <span>{{ scope.row.box_name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="中奖赏品" min-width="300">
        <template slot-scope="scope">
          <div style="display: flex; align-items: center; gap: 6px">
            <img :src="scope.row.box_prize_image" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px" />
            <div>
              <div>{{ scope.row.box_prize_name }}</div>
              <span style="font-size: 12px; color: #409EFF">等级：{{ scope.row.level_name }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="单价" prop="price" width="100" align="center" />
      <el-table-column label="兑换价" prop="recovery_price" width="100" align="center" />
      <el-table-column label="数量" prop="num" width="80" align="center" />
      <el-table-column label="倍数" prop="multiple" width="80" align="center" />
      <el-table-column label="创建时间" prop="created_at" width="180" align="center" />
    </el-table>

    <el-pagination
      @size-change="handleDrawRecordSizeChange"
      @current-change="handleDrawRecordCurrentChange"
      :current-page="drawRecordSearch.page"
      :page-size="drawRecordSearch.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="drawRecordTotal"
      style="margin-top: 15px; text-align: right"
    ></el-pagination>
  </div>
  <div slot="footer">
    <el-button @click="drawRecordDialogVisible = false">关闭</el-button>
  </div>
</el-dialog>
        <!-- ==============================================
             PC 独立弹窗：赏品管理
        ============================================== -->
        <el-dialog
          title="盲盒赏品管理"
          :visible.sync="prizeDialogVisible"
          width="1200px"
          append-to-body
        >
          <div v-loading="prizeLoading" element-loading-text="加载中...">
            <div
              style="
                display: flex;
                gap: 10px;
                align-items: center;
                margin-bottom: 15px;
              "
            >
              <el-select
                v-model="prizeSearch.type"
                placeholder="请选择盲盒类型"
                style="width: 180px"
                clearable
                @change="handleTypeChange"
              >
                <el-option
                  v-for="item in prizeTypeOptions"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-select
                v-model="prizeSearch.level_id"
                placeholder="请选择赏品等级"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in prizeLevelOptions"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
              <el-button
                icon="el-icon-search"
                type="primary"
                @click="getBoxPrizeList"
                >搜索</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetPrizeSearch"
                >重置</el-button
              >
              <el-button
                type="success"
                icon="el-icon-plus"
                @click="openGoodsDialog"
                >添加赏品</el-button
              >
            </div>

            <div style="margin-bottom: 25px">
              <p style="font-weight: bold; margin-bottom: 8px">
                待提交赏品（未保存）
              </p>
              <el-table
                :data="tempPrizeList"
                border
                stripe
                size="small"
                style="width: 100%"
              >
                <el-table-column
                  label="商品ID"
                  prop="goods_id"
                  width="100"
                  align="center"
                />
                <el-table-column label="商品图片" width="100" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.goods_image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="goods_title"
                  min-width="220"
                />
                <el-table-column
                  label="等级ID"
                  prop="level_id"
                  width="90"
                  align="center"
                />
                <el-table-column label="等级名称" width="140" align="center">
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.level_id"
                      size="mini"
                      placeholder="选择等级"
                    >
                      <el-option
                        v-for="item in levelList"
                        :key="item.level_id"
                        :label="item.name"
                        :value="item.level_id"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="价格" width="120" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.price"
                      type="number"
                      size="mini"
                      placeholder="价格"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="兑换价格" width="120" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.recovery_price"
                      type="number"
                      size="mini"
                      placeholder="兑换价"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="赏品类型" width="110" align="center">
                  <template slot-scope="scope">
                    <span
                      :style="{
                        color:
                          scope.row.goods_type == 1 ? '#008000' : '#1890ff',
                      }"
                    >
                      {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      @click="delTempPrize(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div>
              <p style="font-weight: bold; margin-bottom: 8px">
                已有赏品（已保存）
              </p>
              <el-table
                :data="prizeList"
                border
                stripe
                size="small"
                style="width: 100%"
              >
                <el-table-column
                  label="赏品ID"
                  prop="id"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="商品ID"
                  prop="goods_id"
                  width="100"
                  align="center"
                />
                <el-table-column label="商品图片" width="100" align="center">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.goods_image"
                      style="width: 60px; height: 60px; object-fit: cover"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="goods_title"
                  min-width="220"
                />
                <el-table-column
                  label="等级ID"
                  prop="level_id"
                  width="100"
                  align="center"
                />
                <el-table-column
                  label="等级名称"
                  prop="level_name"
                  width="120"
                  align="center"
                />
                <el-table-column
                  label="价格"
                  prop="price"
                  width="120"
                  align="center"
                />
                <el-table-column
                  label="兑换价格"
                  prop="recovery_price"
                  width="120"
                  align="center"
                />
                <el-table-column label="商品类型" width="140" align="center">
                  <template slot-scope="scope">
                    {{
                      scope.row.goods_type == 1
                        ? "真实赏品"
                        : scope.row.goods_type == 2
                        ? "虚拟赏品(钻石)"
                        : "未知"
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="创建时间"
                  prop="created_at"
                  width="180"
                  align="center"
                />
                <el-table-column
                  label="更新时间"
                  prop="updated_at"
                  width="180"
                  align="center"
                />
                <el-table-column
                  label="操作"
                  width="160"
                  align="center"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      icon="el-icon-edit"
                      @click.stop="handleEditPrize(scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="color: #f56c6c"
                      @click.stop="handleDelPrize(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination
                @size-change="handlePrizeSizeChange"
                @current-change="handlePrizeCurrentChange"
                :current-page="prizeSearch.page"
                :page-size="prizeSearch.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="prizeTotal"
                style="margin-top: 15px; text-align: right"
              ></el-pagination>
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="prizeDialogVisible = false">关闭</el-button>
            <el-button
              type="primary"
              icon="el-icon-document-checked"
              @click="submitBoxPrize"
              >保存提交</el-button
            >
          </div>
        </el-dialog>

        <!-- ==============================================
             PC 独立弹窗：编辑赏品
        ============================================== -->
        <el-dialog
          title="编辑赏品"
          :visible.sync="editPrizeDialogVisible"
          width="550px"
          append-to-body
        >
          <div
            style="
              display: flex;
              align-items: center;
              gap: 15px;
              margin-bottom: 20px;
              padding-left: 10px;
            "
          >
            <img
              :src="editPrizeForm.goods_image"
              style="
                width: 70px;
                height: 70px;
                object-fit: cover;
                border-radius: 4px;
              "
              v-if="editPrizeForm.goods_image"
            />
            <div>
              <p style="margin: 0; font-weight: bold">
                商品ID：{{ editPrizeForm.goods_id }}
              </p>
              <p style="margin: 5px 0 0; color: #666">
                商品名称：{{ editPrizeForm.goods_title }}
              </p>
            </div>
          </div>

          <el-form
            :model="editPrizeForm"
            label-width="100px"
            style="margin-top: 10px"
          >
            <el-form-item label="等级">
              <el-select
                v-model="editPrizeForm.level_id"
                placeholder="请选择等级"
              >
                <el-option
                  v-for="item in levelList"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="价格">
              <el-input
                v-model.number="editPrizeForm.price"
                type="number"
                placeholder="请输入价格"
              />
            </el-form-item>
            <el-form-item label="兑换价格">
              <el-input
                v-model.number="editPrizeForm.recovery_price"
                type="number"
                placeholder="请输入兑换价格"
              />
            </el-form-item>
            <el-form-item label="赏品类型">
              <span
                :style="{
                  color: editPrizeForm.goods_type == 1 ? '#008000' : '#1890ff',
                }"
              >
                {{ editPrizeForm.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
              </span>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="editPrizeDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitEditPrize"
              >确认保存</el-button
            >
          </div>
        </el-dialog>

        <!-- ==============================================
             PC 独立弹窗：商品库选择
        ============================================== -->
        <el-dialog
          title="选择商品（可多选）"
          :visible.sync="goodsDialogVisible"
          width="1200px"
          append-to-body
        >
          <div v-loading="goodsLoading" style="padding: 10px">
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-input
                v-model="goodsSearch.title"
                placeholder="商品名称"
                style="width: 240px"
                clearable
              ></el-input>
              <el-select
                v-model="goodsSearch.type"
                placeholder="盲盒类型"
                style="width: 180px"
                clearable
                @change="handleGoodsTypeChange"
              >
                <el-option
                  v-for="item in goodsTypeSelectOptions"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-select
                v-model="goodsSearch.level_id"
                placeholder="等级筛选"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in goodsLevelOptions"
                  :key="item.level_id"
                  :label="item.name"
                  :value="item.level_id"
                />
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getGoodsList"
                >搜索</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetGoodsSearch"
                >重置</el-button
              >
            </div>

            <el-table
              ref="goodsTable"
              :data="goodsList"
              border
              size="small"
              @selection-change="handleGoodsSelectionChange"
              @row-click="handleGoodsRowClick"
            >
              <el-table-column type="selection" width="55" />
              <el-table-column label="ID" prop="id" width="80" align="center" />
              <el-table-column label="商品图片" width="100" align="center">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.image"
                    style="width: 50px; height: 50px; object-fit: cover"
                  />
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="title" min-width="250" />
              <el-table-column
                label="等级"
                prop="level_name"
                width="120"
                align="center"
              />
              <el-table-column
                label="价格"
                prop="price"
                width="100"
                align="center"
              />
              <!-- 新增：赏品类型 -->
              <el-table-column label="赏品类型" width="110" align="center">
                <template slot-scope="scope">
                  <span
                    :style="{
                      color: scope.row.goods_type == 1 ? '#008000' : '#1890ff',
                    }"
                  >
                    {{ scope.row.goods_type == 1 ? "真实赏品" : "虚拟赏品" }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" prop="created_at" width="160" />
            </el-table>

            <el-pagination
              @size-change="handleGoodsSizeChange"
              @current-change="handleGoodsCurrentChange"
              :current-page="goodsSearch.page"
              :page-size="goodsSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="goodsTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>
          <div slot="footer">
            <el-button @click="goodsDialogVisible = false">取消</el-button>
            <el-button type="success" @click="confirmAddGoods"
              >确认添加选中</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.name"
            placeholder="盲盒名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-header">
              <img :src="item.image" class="avatar" />
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="meta">ID:{{ item.id }} | 售价¥{{ item.price }}</div>
              </div>
              <div class="status" :class="item.status == 1 ? 'on' : 'off'">
                {{ item.status == 1 ? "上架" : "下架" }}
              </div>
            </div>
            <div class="card-body">
              <div>销量：{{ item.sales }}</div>
              <div>排序：{{ item.sort }}</div>
              <div>
                利润：
                <span v-if="Number(item.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color: item.income - item.pay >= 0 ? '#00c48c' : '#f56c6c',
                  }"
                >
                  {{
                    (((item.income - item.pay) / item.income) * 100).toFixed(2)
                  }}%
                </span>
              </div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openMobileEdit(item.id)"
                >编辑</el-button
              >
              <el-switch
                v-model="item.status"
                size="mini"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatusChange(item)"
              />
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageTotal"
            pager-count="2"
            small
          />
        </div>

        <!-- ==============================================
             移动端独立弹窗：详情
        ============================================== -->
        <el-dialog
          title="盲盒详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileDetailRow" style="padding: 10px 0">
            <div style="text-align: center; margin-bottom: 15px">
              <img
                :src="mobileDetailRow.image"
                style="
                  width: 120px;
                  height: 120px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
            </div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="盲盒ID">{{
                mobileDetailRow.id
              }}</el-descriptions-item>
              <el-descriptions-item label="盲盒名称">{{
                mobileDetailRow.name
              }}</el-descriptions-item>
              <el-descriptions-item label="价格"
                >¥{{ mobileDetailRow.price }}</el-descriptions-item
              >
              <el-descriptions-item label="排序">{{
                mobileDetailRow.sort
              }}</el-descriptions-item>
              <el-descriptions-item label="销量">{{
                mobileDetailRow.sales
              }}</el-descriptions-item>
              <el-descriptions-item label="收入">{{
                mobileDetailRow.income
              }}</el-descriptions-item>
              <el-descriptions-item label="支出">{{
                mobileDetailRow.pay
              }}</el-descriptions-item>
              <el-descriptions-item label="利润">
                <span v-if="Number(mobileDetailRow.income) === 0">--</span>
                <span
                  v-else
                  :style="{
                    color:
                      mobileDetailRow.income - mobileDetailRow.pay >= 0
                        ? '#00C48C'
                        : '#F56C6C',
                  }"
                >
                  {{
                    (
                      ((mobileDetailRow.income - mobileDetailRow.pay) /
                        mobileDetailRow.income) *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="状态">
                <span
                  :style="
                    mobileDetailRow.status == 1
                      ? 'color:#00C48C'
                      : 'color:#F56C6C'
                  "
                >
                  {{ mobileDetailRow.status == 1 ? "上架" : "下架" }}
                </span>
              </el-descriptions-item>
            </el-descriptions>

            <div style="margin-top: 20px" v-if="mobileProbList.length">
              <p style="font-weight: bold; margin-bottom: 10px">等级概率配置</p>
              <el-table
                :data="mobileProbList"
                border
                size="mini"
                style="width: 100%"
              >
                <el-table-column
                  label="等级"
                  prop="level_name"
                  min-width="100"
                />
                <el-table-column label="概率(%)" align="center">
                  <template slot-scope="scope">
                    {{ parseFloat(scope.row.probability).toFixed(2) }}%
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- ==============================================
             移动端独立弹窗：编辑
        ============================================== -->
        <el-dialog
          title="编辑盲盒"
          :visible.sync="mobileEditVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileEditForm"
            :rules="addRules"
            ref="mobileEditRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="盲盒名称" prop="name">
              <el-input
                v-model="mobileEditForm.name"
                placeholder="名称"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="盲盒图片">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-button
                  type="primary"
                  size="mini"
                  @click="mobileOpenImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="mobileEditForm.image"
                  style="
                    border: 1px solid #eee;
                    padding: 2px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="mobileEditForm.image"
                    style="width: 46px; height: 46px; object-fit: cover"
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="门票ID" prop="goods_id">
              <el-input
                v-model="mobileEditForm.goods_id"
                placeholder="门票ID"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="预估价格" prop="loss_price">
              <el-input
                v-model="mobileEditForm.loss_price"
                placeholder="预估价格"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="mobileEditForm.price"
                placeholder="价格"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="mobileEditForm.sort"
                placeholder="排序"
                size="medium"
              />
            </el-form-item>

            <el-form-item label="等级概率">
              <el-table
                :data="mobileProbList"
                border
                size="mini"
                style="width: 100%"
              >
                <el-table-column
                  label="等级"
                  prop="level_name"
                  min-width="100"
                />
                <el-table-column label="概率(%)" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.probability"
                      type="number"
                      size="mini"
                      style="width: 100px"
                      @change="handleMobileProbChange"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-form>

          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              justify-content: flex-end;
              gap: 10px;
            "
          >
            <el-button size="medium" @click="mobileEditVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileEdit"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- ==============================================
             移动端独立弹窗：图片选择
        ============================================== -->
        <el-dialog
          title="选择图片"
          :visible.sync="mobileImageDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div
            v-loading="mobileImageLoading"
            element-loading-text="加载中..."
            style="padding: 5px"
          >
            <div style="display: flex; gap: 8px; margin-bottom: 10px">
              <el-select
                v-model.number="mobileImageSearch.type"
                placeholder="类型"
                size="mini"
                clearable
                style="flex: 1"
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button size="mini" type="primary" @click="mobileGetImageList"
                >筛选</el-button
              >
              <el-button size="mini" @click="mobileResetImageSearch"
                >重置</el-button
              >
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                max-height: 45vh;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in mobileImageList"
                :key="img.id"
                @click="mobileSelectImage(img)"
                style="
                  padding: 3px;
                  border-radius: 6px;
                  cursor: pointer;
                  text-align: center;
                "
                :style="{
                  border:
                    mobileSelectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    mobileSelectedImageUrl == img.url
                      ? '#f0f7ff'
                      : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 70px;
                    height: 70px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
              </div>
            </div>

            <div style="margin-top: 10px; text-align: center">
              <el-pagination
                @size-change="mobileHandleImageSizeChange"
                @current-change="mobileHandleImageCurrentChange"
                :current-page="mobileImageSearch.page"
                :page-size="mobileImageSearch.page_size"
                layout="prev, pager, next"
                :total="mobileImageTotal"
            pager-count="2"
            small
              />
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button size="mini" @click="mobileImageDialogVisible = false"
              >取消</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="mobileConfirmSelectImage"
              >确认</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "BlindBoxTable",
  data() {
    return {
      // 移动端
      mobileDetailVisible: false,
      mobileDetailRow: null,
      mobileEditVisible: false,
      mobileEditForm: {
        box_id: "",
        name: "",
        image: "",
        price: "",
        sort: "",
        goods_id: "", // 新增
        loss_price: "", // 新增
        wish_probability: "[]",
      },
      mobileProbList: [],

      // 移动端独立图片弹窗
      mobileImageDialogVisible: false,
      mobileImageLoading: false,
      mobileImageList: [],
      mobileImageTotal: 0,
      mobileImageSearch: { page: 1, page_size: 10, type: "" },
      mobileSelectedImageUrl: "",

      // PC 独立图片弹窗
      pcImageDialogVisible: false,
      pcImageLoading: false,
      pcImageList: [],
      pcImageTotal: 0,
      pcImageSearch: { page: 1, page_size: 10, type: "" },
      pcSelectedImageUrl: "",

      loading: false,
      tableData: [],
      pageTotal: 0,
      levelList: [],
      searchParams: { page: 1, page_size: 10, name: "" },

      dialogVisible: false,
      dialogType: "add",
      form: {
        id: "",
        name: "",
        image: "",
        sort: "",
        price: "",
        goods_id: "", // 新增
        loss_price: "", // 新增
        wish_probability: "[]",
      },
      probList: [],
      addRules: {
        name: [{ required: true, message: "请输入盲盒名称", trigger: "blur" }],
        image: [{ required: true, message: "请选择图片", trigger: "change" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        goods_id: [
          { required: true, message: "请输入门票ID", trigger: "blur" },
        ], // 新增
        loss_price: [
          { required: true, message: "请输入预估价格", trigger: "blur" },
        ], // 新增
      },
// 抽奖记录弹窗
drawRecordDialogVisible: false,
drawRecordLoading: false,
drawRecordList: [],
drawRecordTotal: 0,
drawRecordLevelList: [],
currentDrawBoxId: null,
drawRecordSearch: {
  page: 1,
  page_size: 10,
  type: 3,
  box_id: "",
  box: "",
  nickname: "",
  level_id: ""
},
      image_type: [],
      columnOptions: [
        { label: "ID", prop: "id" },
        { label: "盲盒名称", prop: "name" },
        { label: "盲盒图片", prop: "image" },
        { label: "价格", prop: "price" },
        { label: "排序", prop: "sort" },
        { label: "销量", prop: "sales" },
        { label: "收入", prop: "income" },
        { label: "支出", prop: "pay" },
        { label: "利润", prop: "profit" },
        { label: "状态", prop: "status" },
        { label: "创建时间", prop: "created_at" },
        { label: "更新时间", prop: "updated_at" },
        { label: "操作", prop: "action" },
      ],
      checkedColumns: [
        "id",
        "name",
        "image",
        "price",
        "sort",
        "sales",
        "income",
        "pay",
        "profit",
        "status",
        "created_at",
        "updated_at",
        "action",
      ],

      detailDialogVisible: false,
      detailRow: null,
      detailLoading: false,
      detailProbList: [],

      prizeDialogVisible: false,
      prizeLoading: false,
      prizeList: [],
      prizeTotal: 0,
      tempPrizeList: [],
      currentBoxId: null,
      prizeSearch: { page: 1, page_size: 10, type: "", level_id: "" },
      prizeTypeOptions: [],
      prizeLevelOptions: [],

      goodsDialogVisible: false,
      goodsLoading: false,
      goodsList: [],
      goodsTotal: 0,
      goodsSearch: {
        page: 1,
        page_size: 10,
        title: "",
        type: "1",
        level_id: "",
        flag: 3,
      },
      goodsTypeSelectOptions: [],
      goodsLevelOptions: [],
      goodsTypeList: [],
      selectedGoodsList: [],
      existGoodsIds: [],

      editPrizeDialogVisible: false,
      editPrizeForm: {
        prize_id: "",
        goods_id: "",
        goods_title: "",
        goods_image: "",
        level_id: "",
        price: "",
        recovery_price: "",
        goods_type: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // ==============================================
    // 移动端方法
    // ==============================================
    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },
    async openMobileEdit(id) {
      this.loading = true;
      try {
        const res = await api.wishBox.detail({ params: { box_id: id } });
        if (res.data.code == 1000) {
          const d = res.data.data;
          this.mobileEditForm = {
            box_id: d.id,
            name: d.name,
            image: d.image,
            price: d.price + "",
            sort: d.sort + "",
            goods_id: d.goods_id || "", // 新增
            loss_price: d.loss_price || "", // 新增
            wish_probability: JSON.stringify(d.wish_probability || []),
          };
          this.mobileProbList = (d.wish_probability || []).map((item) => ({
            level_id: item.level_id,
            level_name: item.level_name,
            probability: parseFloat(item.probability),
          }));
          this.mobileEditVisible = true;
        }
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    handleMobileProbChange() {
      this.mobileEditForm.wish_probability = JSON.stringify(
        this.mobileProbList
      );
    },
    async submitMobileEdit() {
      const total = this.mobileProbList.reduce(
        (sum, item) => sum + Number(item.probability || 0),
        0
      );
      if (total.toFixed(2) != 100.0) {
        this.$message.error(`概率总和必须=100%，当前：${total.toFixed(2)}%`);
        return;
      }
      if (!this.mobileEditForm.name || !this.mobileEditForm.price) {
        this.$message.warning("请完善必填项");
        return;
      }
      this.loading = true;
      try {
        const res = await api.wishBox.edit(this.mobileEditForm);
        if (res.data.code == 1000) {
          this.mobileEditVisible = false;
          this.getList();
        }
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },

    // ==============================================
    // PC 图片弹窗
    // ==============================================
    pcOpenImageDialog() {
      this.pcImageDialogVisible = true;
      this.pcSelectedImageUrl = "";
      this.pcGetImageList();
    },
    pcGetImageList() {
      this.pcImageLoading = true;
      api.images
        .index({ params: this.pcImageSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.pcImageList = res.data.data.data || [];
            this.pcImageTotal = res.data.data.total || 0;
            this.image_type = res.data.data.image_type || [];
          }
        })
        .finally(() => (this.pcImageLoading = false));
    },
    pcSelectImage(img) {
      this.pcSelectedImageUrl = img.url;
    },
    pcConfirmSelectImage() {
      if (!this.pcSelectedImageUrl) return this.$message.warning("请选择图片");
      this.form.image = this.pcSelectedImageUrl;
      this.pcImageDialogVisible = false;
    },
    // 打开抽奖记录弹窗
openDrawRecordDialog(row) {
  this.currentDrawBoxId = row.id;
  // 重置搜索条件，绑定当前盲盒ID
  this.drawRecordSearch = {
    page: 1,
    page_size: 10,
    type: 3,
    box_id: row.id,
    box: "",
    nickname: "",
    level_id: ""
  };
  this.drawRecordDialogVisible = true;
  this.getDrawRecordList();
},

// 获取抽奖记录列表
async getDrawRecordList() {
  this.drawRecordLoading = true;
  try {
    const res = await api.blindCate.boxDrawRecord({ params: this.drawRecordSearch });
    if (res.data.code == "1000") {
      this.drawRecordList = res.data.data.data || [];
      this.drawRecordTotal = res.data.data.total || 0;
      this.drawRecordLevelList = res.data.data.level_data || [];
    }
  } catch (err) {
    this.$message.error("获取抽奖记录失败");
  } finally {
    this.drawRecordLoading = false;
  }
},

// 重置抽奖记录搜索
resetDrawRecordSearch() {
  this.drawRecordSearch = {
    page: 1,
    page_size: 10,
    type: 3,
    box_id: this.currentDrawBoxId,
    box: "",
    nickname: "",
    level_id: ""
  };
  this.getDrawRecordList();
},

// 分页切换
handleDrawRecordSizeChange(val) {
  this.drawRecordSearch.page_size = val;
  this.getDrawRecordList();
},
handleDrawRecordCurrentChange(val) {
  this.drawRecordSearch.page = val;
  this.getDrawRecordList();
},
    pcResetImageSearch() {
      this.pcImageSearch = { page: 1, page_size: 10, type: "" };
      this.pcGetImageList();
    },
    pcHandleImageSizeChange(val) {
      this.pcImageSearch.page_size = val;
      this.pcGetImageList();
    },
    pcHandleImageCurrentChange(val) {
      this.pcImageSearch.page = val;
      this.pcGetImageList();
    },

    // ==============================================
    // 移动端图片弹窗
    // ==============================================
    mobileOpenImageDialog() {
      this.mobileImageDialogVisible = true;
      this.mobileSelectedImageUrl = "";
      this.mobileGetImageList();
    },
    mobileGetImageList() {
      this.mobileImageLoading = true;
      api.images
        .index({ params: this.mobileImageSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.mobileImageList = res.data.data.data || [];
            this.mobileImageTotal = res.data.data.total || 0;
            this.image_type = res.data.data.image_type || [];
          }
        })
        .finally(() => (this.mobileImageLoading = false));
    },
    mobileSelectImage(img) {
      this.mobileSelectedImageUrl = img.url;
    },
    mobileConfirmSelectImage() {
      if (!this.mobileSelectedImageUrl)
        return this.$message.warning("请选择图片");
      this.mobileEditForm.image = this.mobileSelectedImageUrl;
      this.mobileImageDialogVisible = false;
    },
    mobileResetImageSearch() {
      this.mobileImageSearch = { page: 1, page_size: 10, type: "" };
      this.mobileGetImageList();
    },
    mobileHandleImageSizeChange(val) {
      this.mobileImageSearch.page_size = val;
      this.mobileGetImageList();
    },
    mobileHandleImageCurrentChange(val) {
      this.mobileImageSearch.page = val;
      this.mobileGetImageList();
    },

    // ==============================================
    // PC 原有方法
    // ==============================================
    getList() {
      this.loading = true;
      api.wishBox
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data || [];
            this.pageTotal = res.data.data.total || 0;
            this.levelList = res.data.data.level || [];
          }
        })
        .finally(() => (this.loading = false));
    },
    async handleStatusChange(row) {
      try {
        this.loading = true;
        await api.wishBox.status({ box_id: row.id, status: row.status });
        this.getList();
      } catch (e) {
        row.status = row.status == 1 ? 0 : 1;
      } finally {
        this.loading = false;
      }
    },
    async handleRowClick(row) {
      this.detailLoading = true;
      this.detailRow = null;
      this.detailProbList = [];
      this.detailDialogVisible = true;
      try {
        const res = await api.wishBox.detail({ params: { box_id: row.id } });
        if (res.data.code == 1000) {
          const data = res.data.data;
          this.detailRow = data;
          this.detailProbList = (data.wish_probability || []).map((item) => ({
            level_id: item.level_id,
            level_name: item.level_name,
            probability: parseFloat(item.probability).toFixed(2),
          }));
        }
      } catch (err) {
        this.$message.error("获取详情失败");
      } finally {
        this.detailLoading = false;
      }
    },
    handleAdd() {
      this.dialogType = "add";
      this.resetForm();
      this.probList = this.levelList.map((item) => ({
        level_id: item.level_id,
        level_name: item.name,
        probability: 0,
      }));
      this.dialogVisible = true;
    },
    async handleEdit(id) {
      this.dialogType = "edit";
      this.resetForm();
      this.loading = true;
      try {
        const res = await api.wishBox.detail({ params: { box_id: id } });
        if (res.data.code == 1000) {
          const d = res.data.data;
          this.form = {
            box_id: d.id,
            name: d.name,
            image: d.image,
            price: d.price,
            sort: d.sort + "",
            goods_id: d.goods_id || "", // 新增
            loss_price: d.loss_price || "", // 新增
            wish_probability: JSON.stringify(d.wish_probability),
          };
          this.probList = d.wish_probability.map((item) => ({
            level_id: item.level_id,
            level_name: item.level_name,
            probability: parseFloat(item.probability),
          }));
          this.dialogVisible = true;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    handleProbChange() {
      this.form.wish_probability = JSON.stringify(this.probList);
    },
    submitForm() {
      const total = this.probList.reduce(
        (sum, i) => sum + Number(i.probability || 0),
        0
      );
      if (total.toFixed(2) != 100.0) {
        this.$message.error(
          "概率总和必须为100%，当前：" + total.toFixed(2) + "%"
        );
        return;
      }
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const apiFn =
          this.dialogType == "add" ? api.wishBox.add : api.wishBox.edit;
        apiFn(this.form)
          .then((res) => {
            if (res.data.code == 1000) {
              this.dialogVisible = false;
              this.getList();
            }
          })
          .finally(() => (this.loading = false));
      });
    },
    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, name: "" };
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        name: "",
        image: "",
        sort: "",
        price: "",
        wish_probability: "[]",
      };
      this.probList = [];
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },

    // 赏品相关
    openPrizeDialog(row) {
      if (this.currentBoxId !== row.id) this.tempPrizeList = [];
      this.currentBoxId = row.id;
      this.prizeDialogVisible = true;
      this.resetPrizeSearch();
      this.loadPrizeLevelOptions();
      this.getBoxPrizeList();
    },
    loadPrizeLevelOptions() {
      api.goods.index({ params: this.goodsSearch }).then((res) => {
        if (res.data.code == 1000) {
          this.prizeTypeOptions = res.data.data.goods_level || [];
          this.goodsTypeSelectOptions = res.data.data.goods_level || [];
          this.goodsTypeList = Object.values(res.data.data.goods_type || {});
        }
      });
    },
    handleTypeChange(type) {
      if (!type) {
        this.prizeLevelOptions = [];
        this.prizeSearch.level_id = "";
        return;
      }
      const target = this.prizeTypeOptions.find((item) => item.type === type);
      this.prizeLevelOptions = target ? target.goods_level : [];
      this.prizeSearch.level_id = "";
    },
    getBoxPrizeList() {
      if (!this.currentBoxId) return;
      this.prizeLoading = true;
      const params = {
        box_id: this.currentBoxId,
        type: this.prizeSearch.type,
        level_id: this.prizeSearch.level_id,
        page: this.prizeSearch.page,
        page_size: this.prizeSearch.page_size,
      };
      api.wishBox
        .wishBoxList({ params })
        .then((res) => {
          if (res.data.code == 1000) {
            this.prizeList = res.data.data.data || [];
            this.prizeTotal = res.data.data.total || 0;
          }
        })
        .finally(() => (this.prizeLoading = false));
    },
    resetPrizeSearch() {
      this.prizeSearch = { page: 1, page_size: 10, type: "", level_id: "" };
      this.prizeLevelOptions = [];
      this.getBoxPrizeList();
    },
    handlePrizeSizeChange(val) {
      this.prizeSearch.page_size = val;
      this.getBoxPrizeList();
    },
    handlePrizeCurrentChange(val) {
      this.prizeSearch.page = val;
      this.getBoxPrizeList();
    },
    openGoodsDialog() {
      this.goodsDialogVisible = true;
      this.selectedGoodsList = [];
      this.resetGoodsSearch();
      this.existGoodsIds = this.tempPrizeList.map((item) => item.goods_id);
    },
    getGoodsList() {
      this.goodsLoading = true;
      api.goods
        .index({ params: this.goodsSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.goodsList = res.data.data.data || [];
            this.goodsTotal = res.data.data.total || 0;
            this.$nextTick(() => {
              if (this.$refs.goodsTable && this.existGoodsIds.length) {
                this.goodsList.forEach((row) => {
                  if (this.existGoodsIds.includes(row.id)) {
                    this.$refs.goodsTable.toggleRowSelection(row, true);
                  }
                });
              }
            });
          }
        })
        .finally(() => (this.goodsLoading = false));
    },
    handleGoodsTypeChange(type) {
      if (!type) {
        this.goodsLevelOptions = [];
        this.goodsSearch.level_id = "";
        return;
      }
      const target = this.goodsTypeSelectOptions.find(
        (item) => item.type === type
      );
      this.goodsLevelOptions = target ? target.goods_level : [];
      this.goodsSearch.level_id = "";
    },
    handleGoodsSelectionChange(val) {
      this.selectedGoodsList = val;
    },
    handleGoodsRowClick(row) {
      this.$refs.goodsTable.toggleRowSelection(row);
    },
    confirmAddGoods() {
      if (!this.selectedGoodsList.length)
        return this.$message.warning("请选择商品");
      this.selectedGoodsList.forEach((item) => {
        // ====== 只改这里：真实赏品去重，虚拟赏品不去重 ======
        let isExist = false;
        if (item.goods_type == 1) {
          // 真实商品：判断是否已存在相同 goods_id
          isExist = this.tempPrizeList.some((i) => i.goods_id == item.id);
        }
        // 不存在 或 虚拟商品 → 才添加
        if (!isExist) {
          this.tempPrizeList.push({
            goods_id: item.id,
            goods_title: item.title,
            goods_image: item.image,
            level_id: item.level_id,
            level_name: item.level_name,
            price: item.price || 0,
            recovery_price: item.price || 0,
            goods_type: item.goods_type || 1,
          });
        }
        // ==============================================
      });
      this.goodsDialogVisible = false;
      this.$message.success("添加成功");
    },
    delTempPrize(row) {
      this.tempPrizeList = this.tempPrizeList.filter(
        (item) => item.goods_id != row.goods_id
      );
    },
    resetGoodsSearch() {
      this.goodsSearch = {
        page: 1,
        page_size: 10,
        title: "",
        type: "",
        level_id: "",
        flag: 3,
      };
      this.goodsLevelOptions = [];
      this.getGoodsList();
    },
    handleGoodsSizeChange(val) {
      this.goodsSearch.page_size = val;
      this.getGoodsList();
    },
    handleGoodsCurrentChange(val) {
      this.goodsSearch.page = val;
      this.getGoodsList();
    },
    async submitBoxPrize() {
      if (!this.currentBoxId) return this.$message.warning("盲盒ID不存在");
      if (!this.tempPrizeList.length)
        return this.$message.warning("请先添加赏品");
      const prize_info = this.tempPrizeList.map((item) => ({
        goods_id: Number(item.goods_id),
        level_id: Number(item.level_id),
        price: Number(item.price),
        recovery_price: Number(item.recovery_price),
        goods_type: Number(item.goods_type),
      }));
      const params = {
        box_id: this.currentBoxId,
        prize_info: JSON.stringify(prize_info),
      };
      this.prizeLoading = true;
      try {
        const res = await api.wishBox.addWishBox(params);
        if (res.data.code == 1000) {
          this.getBoxPrizeList();
          this.tempPrizeList = [];
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.prizeLoading = false;
      }
    },
    async handleEditPrize(row) {
      this.editPrizeForm = {
        prize_id: row.id,
        goods_id: row.goods_id,
        goods_title: row.goods_title,
        goods_image: row.goods_image,
        level_id: row.level_id,
        price: row.price,
        recovery_price: row.recovery_price,
        goods_type: row.goods_type,
      };
      this.editPrizeDialogVisible = true;
    },
    async submitEditPrize() {
      this.prizeLoading = true;
      try {
        const submitData = {
          prize_id: this.editPrizeForm.prize_id,
          goods_id: this.editPrizeForm.goods_id,
          level_id: this.editPrizeForm.level_id,
          price: this.editPrizeForm.price,
          recovery_price: this.editPrizeForm.recovery_price,
          goods_type: this.editPrizeForm.goods_type,
        };
        const res = await api.wishBox.editWishBox(submitData);
        if (res.data.code == 1000) {
          this.editPrizeDialogVisible = false;
          this.getBoxPrizeList();
        }
      } catch (e) {
      } finally {
        this.prizeLoading = false;
      }
    },
    async handleDelPrize(row) {
      this.$confirm("此操作将永久删除该赏品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.prizeLoading = true;
          try {
            const res = await api.wishBox.delWishBox({ prize_id: row.id });
            if (res.data.code == 1000) this.getBoxPrizeList();
          } catch (e) {
          } finally {
            this.prizeLoading = false;
          }
        })
        .catch(() => this.$message.info("已取消删除"));
    },
  },
};
</script>

<style scoped>
/* PC */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 移动端 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ee;
  color: #00c48c;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/wishBox/index.vue